// extracted by mini-css-extract-plugin
module.exports = {"h1":"HeaderLogo_SP_h1__254kD","logo":"HeaderLogo_SP_logo__3QUxs","label":"HeaderLogo_SP_label__1TJ-G"};